
declare global {
    interface String {
      is(value: any): boolean;
    }
    interface Number {
      is(value: any): boolean;
    }
    interface Boolean {
      is(value: any): boolean;
    }
    interface Array<T> {
      is(value: any): boolean;
    }
    interface Object {
      is(value: any): boolean;
    }
  }
  
  function deepEqual(a: any, b: any): boolean {
    if (a === b) return true;

    if (typeof a !== 'object' || typeof b !== 'object' || a == null || b == null) return false;

    const keysA = Object.keys(a), keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (let key of keysA) {
        if (!keysB.includes(key)) return false;
        
        if (typeof a[key] === 'object' && typeof b[key] === 'object') {
            if (!deepEqual(a[key], b[key])) return false;
        } else {
            if (a[key] !== b[key]) return false;
        }
    }

    return true;
  }
  
  const literalCompare = {
    value: function (this: any, value: any): boolean {
      return this.valueOf() === value;
    },
    writable: true,
    configurable: true
  };
  
  const deepCompare = {
    value: function (this: any, value: any): boolean {
      return deepEqual(this, value);
    },
    writable: true,
    configurable: true
  };
  
  Object.defineProperty(String.prototype, 'is', literalCompare);
  Object.defineProperty(Number.prototype, 'is', literalCompare);
  Object.defineProperty(Boolean.prototype, 'is', literalCompare);
  Object.defineProperty(Array.prototype, 'is', deepCompare);
  Object.defineProperty(Object.prototype, 'is', deepCompare);
  
  export {};
  